import { ReactElement } from 'react';
import { useRoutes } from 'react-router-dom';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { geographicRoutes } from './routing-config';

/**
 * Router Module
 * @returns {React.ReactElement} - return React Element
 */
const RouterModule = (): ReactElement | null => {
  const authorizationsItems = useRouteAuthorization(geographicRoutes);

  const routes = useRoutes(authorizationsItems);

  return routes;
};

RouterModule.displayName = 'Router Module';

export default RouterModule;
